export enum EDoddleState {
  draft = 'draft',
  scheduled = 'scheduled',
  published = 'published',
  failed = 'failed',
}
